<section>
  <div class="container pt-5 pb-5">
    <h1 class="font-title font-bold mb-3">Our Story</h1>
    <h2 class="font-title font-bold mb-4">
      EnableAll is E-Commerce for everyone.
    </h2>
    <h3 class="font-title font-bold mb-2 mt-4">Our brand promise</h3>
    <p class="mb-4 text-theme-on-surface">
      We are the world’s first, truly accessible online marketplace platform,
      which enables equality and inclusion for disabled people, economic
      opportunities for merchants, and an ethical alternative for conscious
      consumers.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">Why we exist</h3>
    <p class="mb-4 text-theme-on-surface">
      We aspire to help everyone find what they want and need, without hassle or
      frustration with the world’s first inclusive e-commerce platform. We will
      deliver a first-class user experience and service, normalising disability
      accessibility standards in the process.
    </p>
    <p class="mb-3 text-theme-on-surface">
      We are pushing the boundaries and breaking down the barriers between what
      disabled people want to do and what they’re able to do because of limited
      user experience online. We remove the divide and barriers that complex
      digital platforms put in place.
    </p>
    <p class="mb-3 text-theme-on-surface">
      We aim to inspire all online services, encouraging them to provide genuine
      accessibility for all.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">What we do</h3>
    <p class="mb-3 text-theme-on-surface">
      We are a one-stop-shop for all consumers. We are a unique combination of
      supporting non-disabled and disabled people and their businesses, bringing
      them together for good.
    </p>
    <p class="mb-3 text-theme-on-surface">
      We deliver freedom, independence, convenience and choice through our
      expertly created, e-commerce platform, built to be accessible, versatile,
      adaptable and diverse.
    </p>
    <h2 class="font-title font-bold mt-4 mb-5">Exclusively Inclusive</h2>
  </div>
</section>
